<template>
  <div>
    <form>
      <div class="form-group">
        <label class="control-label">
          {{ $t('accounting.rate_information_feature.from_currency') }}
          <span class="text-danger">*</span>
          <i
            class="fas fa-spinner spin"
            v-if="!currencies.length && ready_fetch"
          ></i>
        </label>
        <select
          v-model.number="model.currency_id_from"
          :disabled="!currencies.length && ready_fetch"
          class="form-control"
          :class="{ 'is-invalid': errors.has('currency_id_from') }"
        >
          <option value="" disabled selected style="display: none;">
            {{ $t('select') }}</option
          >
          <option
            v-for="(currency, index) in from_currencies"
            :key="index"
            :value="currency.currency_id"
          >
            {{ currency.currency_name_en }} |
            {{ currency.currency_code }}
          </option>
        </select>
        <div class="invalid-feedback" v-if="errors.has('currency_id_from')">
          {{ errors.first('currency_id_from') }}
        </div>
      </div>
      <div class="form-group">
        <label class="control-label">
          {{ $t('accounting.rate_information_feature.to_currency') }}
          <span class="text-danger">*</span>
          <i
            class="fas fa-spinner spin"
            v-if="!currencies.length && ready_fetch"
          ></i>
        </label>
        <select
          v-model.number="model.currency_id_to"
          :disabled="!currencies.length && ready_fetch"
          class="form-control"
          :class="{ 'is-invalid': errors.has('currency_id_to') }"
        >
          <option value="" disabled selected style="display: none;">
            {{ $t('select') }}</option
          >
          <option
            v-for="(currency, index) in to_currencies"
            :key="index"
            :value="currency.currency_id"
          >
            {{ currency.currency_name_en }} |
            {{ currency.currency_code }}
          </option>
        </select>
        <div class="invalid-feedback" v-if="errors.has('currency_id_to')">
          {{ errors.first('currency_id_to') }}
        </div>
      </div>
      <div class="form-group">
        <label class="control-label">
          {{ $t('accounting.rate_information_feature.rate_amount') }}
          <span class="text-danger">*</span>
        </label>
        <input
          v-model.number="model.rate_amount"
          type="number"
          class="form-control"
          :class="{ 'is-invalid': errors.has('rate_amount') }"
        />
        <div class="invalid-feedback" v-if="errors.has('rate_amount')">
          {{ errors.first('rate_amount') }}
        </div>
      </div>
      <div class="form-group">
        <label class="control-label">
          {{ $t('accounting.rate_information_feature.fee_addon') }}
        </label>
        <input
          v-model.number="model.fee_addon"
          type="number"
          class="form-control"
          :class="{ 'is-invalid': errors.has('fee_addon') }"
        />
        <div class="invalid-feedback" v-if="errors.has('fee_addon')">
          {{ errors.first('fee_addon') }}
        </div>
      </div>
      <div class="text-right">
        <ts-button @click="cancel()" v-if="editing == true">
          {{ $t('cancel') }}
        </ts-button>
        <ts-button
          class="ml-2"
          color="primary"
          :disabled="saving"
          :waiting="saving"
          @click="update"
          v-if="editing == true"
        >
          {{ $t('update') }}
        </ts-button>
        <ts-button
          class="ml-2"
          color="primary"
          :disabled="saving"
          :waiting="saving"
          @click="save"
          v-else
        >
          {{ $t('save') }}
        </ts-button>
      </div>
    </form>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapState, mapActions } from 'vuex'

export default {
  name: 'rate-information-create-form',
  props: ['edit', 'leave'],
  data() {
    return {
      model: {
        rate_id: 0,
        currency_id_from: '',
        currency_id_to: '',
        rate_amount: '',
        fee_addon: 0
      },
      errors: new Errors(),
      saving: false,
      editing: false,
      ready_fetch: false
    }
  },
  created() {
    this.fetchResourceBeforeCreate()
  },
  computed: {
    ...mapState('rateInformation', ['currencies', 'edit_data']),
    from_currencies() {
      return this.currencies.filter(
        c => c.currency_id !== this.model.currency_id_to
      )
    },
    to_currencies() {
      return this.currencies.filter(
        c => c.currency_id !== this.model.currency_id_from
      )
    }
  },
  methods: {
    fetchResourceBeforeCreate() {
      this.ready_fetch = true
      this.$store
        .dispatch('rateInformation/dataBeforeCreate')
        .then(response => {
          this.ready_fetch = false
          this.setEditData()
        })
        .catch(error => {
          this.ready_fetch = false
          this.$toasted.error(error.message)
        })
    },
    save() {
      this.errors = new Errors()
      this.saving = true
      this.$store
        .dispatch('rateInformation/store', this.model)
        .then(response => {
          this.saving = false
          this.clearForm()
          this.$emit('fetch_data')
          this.$toasted.success(response.message)
        })
        .catch(error => {
          this.saving = false
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
    },
    setEditData() {
      if (
        _.isEmpty(this.edit_data) ||
        this.edit_data === null ||
        this.edit_data === undefined
      )
        return
      this.errors = new Errors()
      this.editing = true
      this.model = {
        rate_id: this.edit_data.rate_id,
        currency_id_from: this.edit_data.currency_id_from,
        currency_id_to: this.edit_data.currency_id_to,
        rate_amount: parseFloat(this.edit_data.rate_amount),
        fee_addon: parseFloat(this.edit_data.fee_addon)
      }
    },
    update() {
      this.errors = new Errors()
      this.saving = true
      this.$store
        .dispatch('rateInformation/update', this.model)
        .then(response => {
          this.$emit('fetch_data')
          this.editing = false
          this.saving = false
          this.clearForm()
          this.$toasted.success(response.message)
        })
        .catch(error => {
          this.editing = true
          this.saving = false
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
    },
    cancel() {
      this.editing = false
      this.clearForm()
      this.$store.commit('rateInformation/SET_EDIT_DATA', {})
      this.$emit('fetch_data')
      this.$router.push({ name: 'rate-information' })
    },
    clearForm() {
      this.model = {
        currency_id_from: '',
        currency_id_to: '',
        rate_amount: '',
        fee_addon: 0
      }
    }
  },
  watch: {
    edit_data: {
      handler() {
        if (this.edit_data) {
          this.setEditData()
        }
      }
    }
  }
}
</script>
